import { FormControl, MenuItem, Select } from "@mui/material";
import { RxCaretRight } from "react-icons/rx";
import { useProject } from "../../../../../contexts/project.context";
import { TabActive } from "../../../../../types/project.type";

type Props = {
  triggerAction(action: any): void;
  actionOptions: any;
  label: React.ReactNode;
  disabled?: boolean;
  /**
   * When true (default), Negociação/Fechamento rules filter budget summary actions.
   * Set false for selects that list service categories (e.g. "Adicionar tipo de serviço").
   */
  applyTabActionFilters?: boolean;
  fullWidth?: boolean;
  dashedBorder?: boolean;
  centerLabel?: boolean;
  hideDropdownIcon?: boolean;
  filled?: boolean;
};
const ActionSelect: React.FC<Props> = ({
  triggerAction,
  actionOptions,
  label,
  disabled,
  applyTabActionFilters = true,
  fullWidth = false,
  dashedBorder = false,
  centerLabel = false,
  hideDropdownIcon = false,
  filled = false,
}: Props) => {
  const { tabActive } = useProject();
  const sxOptions = {
    padding: 0,
    height: "80%",
    boxShadow: "none",
    border: dashedBorder ? "1px dashed #1361A4" : "1px solid #1361A4",
    color: "#1361A4",
    background: filled ? "#e3f2fd" : "#FFF",
    width: "100%",
    ...(filled ? { "&:hover": { background: "#d0e7fb" } } : {}),
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      justifyContent: centerLabel ? "center" : "flex-start",
      ...(hideDropdownIcon ? { paddingRight: "14px !important" } : {}),
    },
  };
  function renderMenuOptions() {
    return actionOptions?.map((el: any, index: any) => {
      if (applyTabActionFilters) {
        if (tabActive === TabActive.APPROVED && !["DENY"].includes(el.value))
          return [];
        if (
          tabActive === TabActive.NEGOTIATION &&
          ["DUPLICATE", "NEGOTIATE", "DELETE", "RENAME"].includes(el.value)
        )
          return [];
        if (
          tabActive === TabActive.BUDGET &&
          ["NEW_VERSION"].includes(el.value)
        )
          return [];
      }
      // if(hasClosings && ["APROVE", "NEGOTIATE"].includes(el.value)) return []
      return (
        <MenuItem key={index} value={el.value}>
          {el.label}
        </MenuItem>
      );
    });
  }
  return (
    <FormControl size="small" fullWidth={fullWidth}>
      <Select
        IconComponent={hideDropdownIcon ? () => null : RxCaretRight}
        disableUnderline={true}
        sx={sxOptions}
        size="small"
        value={""}
        displayEmpty
        id="simple-select"
        placeholder="Selecione"
        onChange={(e) => {
          triggerAction(e.target.value);
        }}
        disabled={disabled}
      >
        <MenuItem disabled value="">
          <em
            style={{
              fontSize: "13px",
              color: "#1361A4",
              fontStyle: "normal",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            {label}
          </em>
        </MenuItem>
        {renderMenuOptions()}
      </Select>
    </FormControl>
  );
};

export default ActionSelect;
